module.exports = __webpack_public_path__ + "static/media/pre.e81aa4f4.svg";